import { useNavigate, useSearchParams } from 'react-router-dom';
import React, { useState } from 'react';

import { isAdmin } from '@utils/Util';

import TaskConfigurationTopbar from '@/features/task-configuration/components/TaskConfigurationTopbar';
import TaskConfigurationTable from '@/features/task-configuration/components/TaskConfigurationTable';
import CreateAndEditTask from '@/features/task-configuration/components/CreateAndEditTask';
import { useGetTaskConfigurationsQuery } from '@/features/task-configuration/api/taskConfigurationApi';
import { useTaskConfigurations } from '@/store/reducers';
import useDebounce from '@/hooks/useDebounce';
import CommonImage from '@/components/CommonImage';
import TaskJourneyConfiguration from '@/features/task-configuration/components/TaskJourneyConfiguration';
import { TAB_LIST, TASK_CONFIGURATIONS_TAB_ITEMS } from '@/features/task-configuration/constants';
import DashboardConfiguration from '@/features/task-configuration/components/DashboardConfiguration';
import FilterConfiguration from '@/features/task-configuration/components/FilterConfiguration';
import SopAndTutorials from '@/features/task-configuration/components/SopAndTutorials';

const TaskConfigurationDetails = () => {
	const [searchKey, setSearchKey] = useState('');
	const [isOpenTaskModal, setOpenTaskModal] = useState(false);

	const [selectedTaskToEdit, setSelectedTaskToEdit] = useState(null);
	const [searchParams, setSearchParams] = useSearchParams();

	const activeTab = searchParams.get('tab') || TAB_LIST.TASK;
	const editFilterId = searchParams.get('editFilterId');

	const [openPrimarySettings, setOpenPrimarySettings] = useState(!!editFilterId);

	const setActiveTab = (tabName) => {
		setSearchParams({ tab: tabName });
	};

	const debouncedValue = useDebounce(searchKey, 500);
	const navigate = useNavigate();
	const { taskList = [] } = useTaskConfigurations();

	useGetTaskConfigurationsQuery({
		params: { search: debouncedValue || '' }
	});

	const handleEditTask = (task) => {
		setSelectedTaskToEdit(task);
		setOpenTaskModal(true);
	};

	// Render tab component based on active Tab
	const tabComponentMap = {
		[TAB_LIST.TASK]: <TaskConfigurationTable onEditTask={handleEditTask} />,
		[TAB_LIST.JOURNEY]: <TaskJourneyConfiguration />,
		[TAB_LIST.CREATE_LIST]: (
			<FilterConfiguration
				openPrimarySettings={openPrimarySettings}
				setOpenPrimarySettings={setOpenPrimarySettings}
				editFilterId={editFilterId}
			/>
		),
		[TAB_LIST.CREATE_DASHBOARD]: <DashboardConfiguration />,
		[TAB_LIST.SOP_AND_TUTORIALS]: <SopAndTutorials />
	};

	return (
		<>
			<div className="top-header bg-white">
				<div className="page-title-area pb-3">
					<p className="semibold-14 gray_dark_02">
						{!activeTab && (
							<CommonImage
								src="/icons/back-arrow-gray.svg"
								className="cursor-pointer"
								onClick={() => navigate('/configuration')}
							/>
						)}
						Task configuration
					</p>
				</div>
				<div className="navigation-tab ">
					<ul>
						{TASK_CONFIGURATIONS_TAB_ITEMS?.map((item) => (
							<li
								className={`${activeTab === item?.id ? 'active' : ''}`}
								onClick={() => setActiveTab(item?.id)}
							>
								{item?.label}
							</li>
						))}
					</ul>
				</div>
			</div>
			{activeTab === TAB_LIST.TASK && (
				<TaskConfigurationTopbar
					onSearch={setSearchKey}
					searchKey={searchKey}
					onOpenCreateTaskModal={setOpenTaskModal}
					itemCount={taskList?.length || 0}
				/>
			)}

			<div className="task-configuration-container px-4">
				{/* Active Tab component */}
				{tabComponentMap[activeTab]}

				{/* Modals  */}
				{isOpenTaskModal && isAdmin() && (
					<CreateAndEditTask
						onClose={() => {
							setOpenTaskModal(false);
							setSelectedTaskToEdit(null);
						}}
						selectedTaskToEdit={selectedTaskToEdit}
					/>
				)}
			</div>
		</>
	);
};

export default TaskConfigurationDetails;
